export default {
  "content": "<path d=\"M18 5h-3.22l-3.5 14H14v2H6v-2h3.22l3.5-14H10V3h8v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};